import { SvgIcon } from "@material-ui/core";

export const ArrowDouble = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g clipPath="url(#clip0_5447_49170)">
      <path d="M4.27594 4L3.33594 4.94L6.38927 8L3.33594 11.06L4.27594 12L8.27594 8L4.27594 4Z" fill="currentColor"/>
      <path d="M8.66656 4L7.72656 4.94L10.7799 8L7.72656 11.06L8.66656 12L12.6666 8L8.66656 4Z" fill="currentColor"/>
    </g>
  </SvgIcon>
);